export const equipmentType = ['computer', 'tablet', 'phone'] as const
export type EquipmentType = (typeof equipmentType)[number]

export const equipmentTypeLabel = {
  computer: 'Ordinateur',
  tablet: 'Tablette',
  phone: 'Téléphone',
} as const
